import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { enterLeave } from 'src/app/animations/common.animations';
import { HeadingComponent } from 'src/app/components/heading/heading.component';
import { InformativeComponent } from 'src/app/components/informative/informative.component';
import { CheckboxControl } from 'src/app/form-controls/checkbox/checkbox.control';
import { ComplicationsPickerControl } from 'src/app/form-controls/complications-picker/complications-picker.control';
import { DateTimeControl } from 'src/app/form-controls/datetime/datetime.control';
import { GroupRepeaterControl } from 'src/app/form-controls/group-repeater/group-repeater.control';
import { ModalityBodyPartsPickerControl } from 'src/app/form-controls/modality-body-parts-picker/modality-body-parts-picker.control';
import { MultiCheckboxControl } from 'src/app/form-controls/multi-checkbox/multi-checkbox.control';
import { MultiItemPickerControl } from 'src/app/form-controls/multi-item-picker/multi-item-picker.control';
import { MultiTextInputControl } from 'src/app/form-controls/multi-text-input/multi-text-input.control';
import { SelectWithInfoControl } from 'src/app/form-controls/select-with-info/select-with-info.control';
import { SelectControl } from 'src/app/form-controls/select/select.control';
import { ServicePickerControl } from 'src/app/form-controls/service-picker/service-picker.control';
import { TextInputControl } from 'src/app/form-controls/text-input/text-input.control';
import { TextAreaControl } from 'src/app/form-controls/textarea/textarea.control';
import { UserPickerControl } from 'src/app/form-controls/user-picker/user-picker.control';
import { UserSignatureControl } from 'src/app/form-controls/user-signature/user-signature.control';
import { DocumentViewModel } from 'src/app/services/document-instance-build.service';
import { WidgetMetadataMapperService } from 'src/app/services/widget-metadata-mapper.service';
import { Section } from 'src/app/types/aggregate-graph.types';

@Component({
	selector: 'app-document-section',
	templateUrl: './document-section.component.html',
	styleUrl: './document-section.component.scss',
	imports: [
		ComplicationsPickerControl, HeadingComponent, InformativeComponent, TextInputControl, TextAreaControl, CheckboxControl, DateTimeControl, SelectControl, SelectWithInfoControl,
		UserPickerControl, UserSignatureControl, ServicePickerControl, MultiTextInputControl, MultiCheckboxControl, MultiItemPickerControl,
		ModalityBodyPartsPickerControl, GroupRepeaterControl, JsonPipe, ReactiveFormsModule
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [enterLeave]
})
export class DocumentSectionComponent {

	@Input() section!: Section;
	@Input() viewModel!: DocumentViewModel;
	@Input() isReadOnly!: boolean;

	constructor(public widgetMetadataMapperService: WidgetMetadataMapperService) {
	}

	getWidgetControl(widgetId: number) {
		return this.viewModel.widgetControls[widgetId] as FormControl<any>;
	}
}